// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"styles_boxWrapper__TBjTs","boxList":"styles_boxList__3eyUO","responsive":"styles_responsive__e043I"};